import Icon1 from "../../../../../assets/images/png/courses/icons/icon1.svg";
import Icon2 from "../../../../../assets/images/png/courses/icons/icon2.svg";
import Icon3 from "../../../../../assets/images/png/courses/icons/icon3.svg";
import Icon4 from "../../../../../assets/images/png/courses/icons/icon4.svg";

import Instructor1 from "../../../../../assets/images/png/courses/instructors/trainers pictures/OMODARA SUIT -  Product and Digital Marketing Practice Lead.png";
import OmobosolaImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/OMOBOSOLA SUIT - Product & Digital Marketing and AI Automation Support Person.png";
import FemiImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/FEMI SUIT - Product Management Practice Lead.png";
import JelilImage from "../../../../../assets/images/png/courses/instructors/jelil.webp";
import SerahmercyImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/SERAHMERCY SUIT - Product Management & Design and Software Development Support Person.png";

import TestimonialImage from "../../../../../assets/images/png/courses/testimonies/ikyo.jpeg";

import Testimony2 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/eniola.webp";
import Testimony1 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/ikyo.webp";

import AkinwaleImage from "../../../../../assets/images/png/courses/testimonies/akinwale.png";
import OludotunImage from "../../../../../assets/images/png/courses/testimonies/oludotun.png";
import AjumokeImage from "../../../../../assets/images/png/courses/testimonies/ajumoke.png";
import VanessaImage from "../../../../../assets/images/png/courses/testimonies/vanessa.png";
import DigitalFabImage from "../../../../../assets/images/png/courses/testimonies/digital fab.png";
import OluwatominiImage from "../../../../../assets/images/png/courses/testimonies/oluwatomini.png";
import ElijahImage from "../../../../../assets/images/png/courses/testimonies/elijah.png";
import HalimatImage from "../../../../../assets/images/png/courses/testimonies/halimat.png";
import AdenikeImage from "../../../../../assets/images/png/courses/testimonies/adenike.png";
import MiracleImage from "../../../../../assets/images/png/courses/testimonies/miracle.png";

import PortfolioImage from "../../../../../assets/images/png/courses/portfolio/product.webp";

import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";
import ProductMarketingPreview from "../../../../../assets/images/jpeg/pdmPreview.jpg";

export const productMarketingAfrica = {
  id: 1,
  tag: "COHORT 2026",
  title: "Product and Digital Marketing Bootcamp",
  seoTitle: "Product & Digital Marketing Bootcamp | Utiva Nigeria",
  description: `
  Designed for people exploring the tech industry as product and digital marketers — future
  B2B, B2C, and SaaS growth leads, analytics managers, email marketers, SEO specialists, and
  content managers taking new products to global markets.
    `,
  heroSubtitle:
    "Learn product and digital marketing — positioning, content, growth channels, and go-to-market strategy — through live weekend classes and real business cases.",
  traineeCountLabel: "500+ professionals trained",
  metatags: `Turn products into demand people can't ignore. Master product marketing, growth channels, and go-to-market strategy with Utiva's Product and Digital Marketing Bootcamp.`,
  duration: "3 Months",

  downloadBrochureUrl:
    "https://drive.google.com/file/d/1xMOoZ6TPK01OuAdeviqvX4zHpdOcxLk0/view?usp=sharing",

  courseFormUrl: "courses/product-marketing-bootcamp/fill-form",

  jobTitle: "Product Marketer",

  kickoffDate: "July 18, 2026",
  kickoffTime: "Weekends only",

  testimonial: {
    image: TestimonialImage,
    name: "Terhile Ikyo",
    role: "Senior Project Manager, Helium Health ",
    testimony: `
    This course is everything a Product Marketer needs and it explores the
    unique role of PMM in a way that has simply not been done before. Every lesson has actionable learnings
    and sparks new ideas, making this PMM excited to roll up their sleeves and get to work.`,
    starRating: "5.0",
  },

  descriptionHeading: "Vetted by senior marketers, built for real campaigns",

  courseOverview: {
    title: `Turn products into demand people can't ignore.`,
    desc: (
      <>
        This program is vetted, tested, and approved by senior-level PMMs from
        companies like Salesforce, Spotify, Google, Meta, Flutterwave, and
        Paystack, so you can be sure you&rsquo;re getting the real deal.
        <br />
        <br />
        We partnered with positioning specialists in the industry to co-create
        our positioning and messaging module, and teamed up with product
        marketing powerhouses throughout the rest of the course.
      </>
    ),
  },

  keyOutcomesHeading: "",

  keyOutcomes: [
    {
      label: "Position",
      desc:
        "Define what a product marketer does, run qualitative and quantitative research, and shape a message that lands.",
    },
    {
      label: "Create",
      desc:
        "Write and design content across formats, from SEO pages to social, email, and AI-assisted content workflows.",
    },
    {
      label: "Distribute",
      desc:
        "Run paid, earned, and owned campaigns across search, social, and display — and read the results.",
    },
    {
      label: "Grow",
      desc:
        "Set OKRs, enable sales, design onboarding, and take a product to market with a clear launch strategy.",
    },
  ],

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Introduction to Product Marketing",
      unitTag: "Product Marketing",
      unitDescription: `
      Understand the strategic role of product marketing in connecting customer needs, product
      value, and business growth through research, positioning, messaging, and go-to-market execution.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "What is product marketing?",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "The difference between Product Management (PM) and Product Marketing Management (PMM)",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Qualitative vs. quantitative research",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "How to create and share a survey",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 2,
      unitTitle: "Digital Marketing Fundamentals",
      unitTag: "Fundamentals",
      unitDescription: `
      Leveraging online channels to reach target audiences, using strategies that optimise
      engagement and conversion.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle:
            "The advent of digital marketing: concepts and channels",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Understanding your target audience: buyer and user persona",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle:
            "Mapping USPs, competitive analysis, objectives, and KPIs",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle:
            "STDC (See, Think, Do, Care) framework and micro-moments",
          featureDescription: ``,
        },
        {
          featureIcon: Icon1,
          featureTitle:
            "Campaign strategy using the media mix: paid, earned, owned",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 3,
      unitTitle: "Pricing and Business Model",
      unitTag: "Model",
      unitDescription: `
      Pricing strategy shapes how a product's value is perceived and how a business stays
      competitive and profitable.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Cost-plus pricing",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Competitor-based pricing",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Value-based pricing",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Freemium pricing",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 4,
      unitTitle: "Content Marketing",
      unitTag: "Marketing",
      unitDescription: `
      Storytelling, strategic content creation, and distribution — including how AI has changed
      content creation while still needing human oversight for authenticity and ethics.
            `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Creation vs. curation, storytelling, and copywriting",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "The 3H of content creation",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Content plan development: pillars, calendar, outline",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Distribution hacks, tools, trendspotting, viral marketing",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle:
            "AI in content marketing: text, visual, and video tools",
          featureDescription: ``,
        },
        {
          featureIcon: Icon1,
          featureTitle:
            "Ethical considerations: bias mitigation and fact-checking",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 5,
      unitTitle: "Social Media Marketing",
      unitTag: "Organic + Paid",
      unitDescription: `
      Understanding platforms, audience engagement, and effective ad campaigns across the
      major networks.
              `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Social media landscape, principles, and strategy",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Shareable content for Facebook, Instagram, TikTok, LinkedIn, YouTube, X, Snapchat",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Setting up optimised social media ads",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 6,
      unitTitle: "Objective Key Results (OKRs)",
      unitTag: "Metrics",
      unitDescription: `
      Set measurable goals that align marketing activity with strategic business objectives.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Introduction to OKRs",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Go-to-market OKRs",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Sales enablement OKRs",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Lead-gen OKRs",
          featureDescription: ``,
        },
        {
          featureIcon: Icon1,
          featureTitle: "Product adoption OKRs",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 7,
      unitTitle: "Introduction to Personas",
      unitTag: "Persona",
      unitDescription: `
      Accurate personas help a brand tailor messaging and channel choices for maximum impact.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Persona template",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Buyer vs. user personas",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Creating and effectively using personas",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 8,
      unitTitle: "Positioning and Messaging",
      unitTag: "Marketing",
      unitDescription: `
      Positioning defines how a brand is perceived; messaging keeps that perception consistent
      across every channel.
            `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Using Canva for messaging",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Using Medium as a messaging tool",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 9,
      unitTitle: "Communication",
      unitTag: "Marketing",
      unitDescription: `
      Effective communication underpins every other marketing skill in this course.
              `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Why communication is important",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Tips for better communication",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Activities to develop communication skills",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 10,
      unitTitle: "Search Engine Optimization",
      unitTag: "Marketing",
      unitDescription: `
      SEO helps a site rank higher on search engines, improving visibility and organic traffic.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Technical SEO",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Off-page SEO and landing page optimisation",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "On-page SEO and keyword research",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Google Search Console",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 11,
      unitTitle: "Go-to-Market Strategy",
      unitTag: "Marketing",
      unitDescription: `
        Outlines the process of launching and scaling a product successfully.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Go-to-market overview",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "3-step growth strategy",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "GTM process and launch timing",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Communicating your GTM strategy",
          featureDescription: ``,
        },
        {
          featureIcon: Icon1,
          featureTitle: "GTM templates",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 12,
      unitTitle: "Search Engine Marketing & Media Buying",
      unitTag: "Sales, Revenue",
      unitDescription: `
      Paid advertising's role in digital marketing success, from search to display.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Running search engine marketing campaigns",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Display campaigns and Google Ads",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "A/B testing, PPC, and CPC bidding",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 13,
      unitTitle: "LinkedIn Optimization",
      unitTag: "LinkedIn",
      unitDescription: `
     Optimising LinkedIn for stronger professional branding and networking.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Profile and content optimisation for reach",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Building a professional network with intent",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 14,
      unitTitle: "Email Marketing",
      unitTag: "Marketing",
      unitDescription: `
      Still one of the most powerful tools for lead nurturing and customer engagement.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Executing email marketing campaigns",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Building an email list with lead magnets",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Automation and success metrics",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 15,
      unitTitle: "Sales Enablement",
      unitTag: "Marketing",
      unitDescription: `
      Aligning marketing and sales teams to improve revenue generation.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Understanding sales enablement strategy",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Adopting a sales enablement strategy",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Creating a sales playbook",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Aligning with the sales team",
          featureDescription: ``,
        },
        {
          featureIcon: Icon1,
          featureTitle: "Measuring sales enablement success",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 16,
      unitTitle: "Introduction to Onboarding",
      unitTag: "Onboarding Frameworks",
      unitDescription: `
     A seamless onboarding process improves customer retention and user experience.
            `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Customer onboarding process",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Onboarding best practices",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Improving retention rate",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 17,
      unitTitle: "Analysis & Optimization",
      unitTag: "Analytics",
      unitDescription: `
      Data-driven optimisation improves campaign performance and future decision-making.`,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Analysis fundamentals",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Key areas to analyse",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "A/B testing",
          featureDescription: ``,
        },
      ],
    },
  ],

  courseCoaches: [
    {
      coachId: 1,
      coachImage: Instructor1,
      coachName: "Oluwaseun Omodara",
      coachRole: "Senior Product and Digital Marketer",
      coachQuote:
        "This course is everything a product marketer needs — every lesson has actionable learnings that spark new ideas.",
    },
    {
      coachId: 2,
      coachImage: FemiImage,
      coachName: "Oluwafemi Ojoko",
      coachRole: "Senior Product Manager",
    },
    {
      coachId: 3,
      coachImage: JelilImage,
      coachName: "Jelil Ajao",
      coachRole: "Product Designer",
    },
    {
      coachId: 4,
      coachImage: OmobosolaImage,
      coachName: "Omobosola Olafimihan",
      coachRole: "Product & Digital Marketing Support",
    },
    {
      coachId: 5,
      coachImage: SerahmercyImage,
      coachName: "Serahmercy Olaoye",
      coachRole: "Product Management & Design Support",
    },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "3 Months, Hands-On",
      modelDescription:
        "An experiential learning and hands-on training journey, not a lecture series.",
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "Real-Life Problems",
      modelDescription:
        "Every lesson is built around a business case, not an abstract exercise.",
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "Case-Driven",
      modelDescription:
        "Apply what you learn directly to a live business problem across the cohort.",
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "50 / 50 Delivery",
      modelDescription:
        "Half your time in self-paced material, half in live weekend classes.",
    },
  ],

  studentTestimonies: [
    {
      id: 1,
      linkedIn: "https://www.linkedin.com/in/eniola-orireyemi-872357117/",
      image: Testimony2,
      firstname: "Eniola",
      lastname: "Orireyemi",
      company: "Product Marketing Manager, truQ",
      testimony: `
      My training at Utiva was really great. I took the training in 2020, and to a very
      large extent, it's still one of the most solid training experiences I've had. I still
      recommend Utiva till date.
      `,
    },
    {
      id: 2,
      linkedIn: "https://www.linkedin.com/in/terhileikyo/",
      image: Testimony1,
      firstname: "Terhile",
      lastname: "Ikyo",
      company: "Senior Project Manager, Helium Health",
      testimony: `
      This course is everything a product marketer needs, and it explores the unique role
      of a PMM in a way that has simply not been done before. Every lesson sparks new ideas.
      `,
    },
    {
      id: 3,
      linkedIn: "",
      image: "",
      firstname: "Obianuju",
      lastname: "Akinlolu",
      company: "",
      testimony: `
      I did the Product Marketing Training with Utiva and it was a truly immersive session with
      teachings, exercises, role plays and a capstone project. I highly recommend.
      `,
    },
    {
      id: 4,
      linkedIn: "",
      image: AkinwaleImage,
      firstname: "Akinwale",
      lastname: "Oluwaseyi",
      company: "",
      testimony: `
      My experience at Utiva during the Product and Digital Marketing Program (December Cohort) was a
      valuable and enlightening learning journey. I enrolled and got a scholarship in the Product and
      Digital Marketing program, which consisted of 21 chapters and 125 lessons covering important
      topics such as product marketing, digital strategy, customer research, and growth marketing. The
      course content was well-organized and practical, making it easier to understand both the
      theoretical concepts and their real-world applications. The program also encouraged independent
      learning and discipline. My trainer, Oluwaseun Omodara, played an important role in the learning
      process. His guidance, knowledge, and willingness to support students helped make the course more
      engaging and meaningful. Overall, my experience at Utiva was positive and educational. The Product
      and Digital Marketing program provided useful knowledge and practical skills that are relevant in
      today's digital economy. I appreciate the opportunity to have been part of the program and would
      recommend Utiva to anyone interested in learning digital marketing and product development.
      `,
    },
    {
      id: 5,
      linkedIn: "",
      image: "",
      firstname: "Destiny",
      lastname: "Ezenwambu",
      company: "",
      testimony: `
      My experience as a student of the Product and Digital Marketing course at Utiva so far has been
      great, the classes have been going on smoothly. I must say that registering with Utiva is one
      decision I can never regret.
      `,
    },
    {
      id: 6,
      linkedIn: "",
      image: OludotunImage,
      firstname: "Oludotun",
      lastname: "David",
      company: "",
      testimony: `
      Coach Omodara, as he is fondly called, happens to be my trainer in my ongoing Utiva course -
      Product and Digital Marketing, and I'd like to say he's been very good generally. I can relate
      with his live classes too well because of his use of life experiences that helps to drive home
      some points. Overall, the Utiva training has been worth taking and I can't wait to graduate as I
      know there is a lot more to come out of it.
      `,
    },
    {
      id: 7,
      linkedIn: "",
      image: "",
      firstname: "Ndubueze",
      lastname: "Deborah",
      company: "",
      testimony: `
      It has been an amazing experience and teaching, a lot was taught. Mr Omodara is really good, from
      the beginning of the topic Digital Marketing till the practical aspect he really nailed each
      topic, even though I followed virtually yet I understand and he always follows up too. FLN
      Foundation really equipped us to the core, thank you so much for the opportunity. Miss Debby,
      appreciate all your effort.
      `,
    },
    {
      id: 8,
      linkedIn: "",
      image: "",
      firstname: "Ogooluwa",
      lastname: "Adeoti",
      company: "",
      testimony: `
      Training with Coach Omodara has been rewarding. His clear communication makes learning easy and
      effective. Utiva stands out as a top tech learning platform.
      `,
    },
    {
      id: 9,
      linkedIn: "",
      image: AjumokeImage,
      firstname: "Ajumoke",
      lastname: "Babatunde-Lawal",
      company: "",
      testimony: `
      I thoroughly enjoyed the Product and Digital Marketing course at Utiva. It was incredibly
      insightful. My instructor, Omodara, did an excellent job of breaking down complex concepts and
      explaining them clearly. I highly recommend this course to anyone looking to learn product and
      digital marketing.
      `,
    },
    {
      id: 10,
      linkedIn: "",
      image: VanessaImage,
      firstname: "Vanessa",
      lastname: "Usen",
      company: "",
      testimony: `
      It's been a fantastic experience if I'm being honest. Much so, knowing the class is coming to an
      end made me realise how much impact the course has brought. Mr Oluwaseun is a fantastic tutor and
      has been really helpful taking me on this journey of digital and product marketing.
      `,
    },
    {
      id: 11,
      linkedIn: "",
      image: "",
      firstname: "Benita",
      lastname: "Ekemita",
      company: "",
      testimony: `
      My experience with Utiva has been enriching and practical. The training has helped me build a
      strong foundation in digital and product marketing, with hands-on tasks that truly push you to
      apply what you learn. A special shoutout to Oluwaseun Omodara, whose clear and supportive teaching
      style has made a huge difference in my learning journey. His feedback and guidance have been
      incredibly valuable. I'm grateful for the experience and excited to keep building on what I've
      learned so far.
      `,
    },
    {
      id: 12,
      linkedIn: "",
      image: DigitalFabImage,
      firstname: "Digital",
      lastname: "Fab",
      company: "",
      testimony: `
      Signing up for the digital marketing course with Utiva in January is one of the best decisions I
      made this year. I had my expectations, and their level of professionalism exceeded them. I was
      always looking forward to my classes with Mr Omodara, my tutor. He is highly knowledgeable,
      patient and always ready to help. Thank you for the knowledge imparted. I am grateful because it
      was worth every penny and time.
      `,
    },
    {
      id: 13,
      linkedIn: "",
      image: OluwatominiImage,
      firstname: "Oluwatomini",
      lastname: "Silva-Ope",
      company: "",
      testimony: `
      I recently completed a Product and Digital Marketing certification course with Utiva, and I can
      confidently say they offer one of the best learning experiences in Nigeria. My trainer, Mr.
      Oluwaseun Omodara, is highly skilled and made the 5-month program both insightful and practical. I
      highly recommend Utiva for anyone looking to build digital skills.
      `,
    },
    {
      id: 14,
      linkedIn: "",
      image: ElijahImage,
      firstname: "Elijah",
      lastname: "Olupona",
      company: "",
      testimony: `
      Seun Omodara is one of the most outstanding instructors I've encountered at Utiva. His teaching
      style is clear, engaging, and incredibly effective. He breaks down complex concepts into simple,
      practical insights that are easy to grasp and apply in real-world situations. Seun genuinely cares
      about his students' growth, always creating a supportive learning environment and going the extra
      mile to ensure everyone stays on track. His depth of knowledge, patience, and passion for teaching
      are truly inspiring. If you're looking to gain real value from your learning experience at Utiva,
      having Seun as your instructor is a major advantage. Highly recommended!
      `,
    },
    {
      id: 15,
      linkedIn: "",
      image: HalimatImage,
      firstname: "Halimat",
      lastname: "Oyiza Suleiman",
      company: "",
      testimony: `
      Oluwaseun Omodara was my coach for PDM, an incredible coach, he knows the topic and always does
      justice to it, he listened, explained to us in detail, learning from him has been an inspiring
      journey. Thank you for being awesome, Mr Omodara.
      `,
    },
    {
      id: 16,
      linkedIn: "",
      image: AdenikeImage,
      firstname: "Adenike",
      lastname: "Olabode",
      company: "",
      testimony: `
      I recently completed the 3-month Product and Digital Marketing training at Utiva, and it exceeded
      my expectations. The well-structured curriculum blended theory with hands-on practice, covering
      growth hacking, digital campaigns, and collaborative projects like the AppSumo Capstone Team. A
      standout part of the program was my trainer, Mr. Oluwaseun Omodara, whose expertise and
      mentorship—especially in Google Analytics and SEO—made the learning seamless. Beyond
      certification, I now confidently analyze customer behavior and design data-driven campaigns—a
      career game-changer. Utiva's program is a worthwhile investment for actionable marketing skills,
      and I'm excited to apply what I've learned. Big thanks to Mr. Omodara and Utiva for this
      transformative experience.
      `,
    },
    {
      id: 17,
      linkedIn: "",
      image: MiracleImage,
      firstname: "Miracle",
      lastname: "Ogbu",
      company: "",
      testimony: `
      This class was amazing, learning about digital marketing, steps to scaling up, and becoming
      proficient in this awesome niche. Thank you for the class, I am so glad I attended. Great job team
      Utiva.
      `,
    },
  ],

  portofolio: {
    title: "Build Solutions around Real Business Cases",
    subtitle:
      "Don’t just say you can market a product. Show it — with a case study built alongside industry mentors.",
    description: `
    Work on a live business case developed with industry mentors — applying research,
    messaging, channel strategy, and GTM planning to a product a real company is trying
    to grow.
      `,

    deliverables: [
      "Weekly, mentor-reviewed milestones",
      "A finished go-to-market plan and messaging kit",
      "A portfolio-ready marketing case study",
    ],

    name: "Olatunji Abayomi",
    // image: PortfolioUserAvatar,
    portfolioImage: PortfolioImage,
  },

  certification: {
    title: "A Utiva Certificate, Made to Be Shared",
    description: `
    Upon completing the course, you'll receive an industry-recognised, professional
    certificate — formatted for sharing on LinkedIn.
      `,
  },

  // videoTestimonial: "https://www.youtube.com/embed/EwYGCtYJr-0",
  // videoTestimonial: "https://www.youtube.com/embed/4AwIysmIQPk",
  videoTestimonial: "https://www.youtube.com/embed/xXIScvXplOQ",
  videoPreviewImage: ProductMarketingPreview,

  otherCourses: [
    {
      id: 1,
      courseTitle: "Product Accelerator",
      courseDescription: `This training is designed by top professionals to help you fast-track
      your career in Product Management. Designed for those that already
      have their foot in the industry and want to fast-track their career.`,
      courseUrl: "/courses/product-management-and-design-bootcamp",
    },
  ],
};
